import { FC, PropsWithChildren } from 'react';

import './styles.scss';

const NewsList: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className="newsContentWrp">
      <div className="newsContentInner">{children}</div>
    </div>
  );
};

export default NewsList;
